/**
 * This object manages the loading bar. So you can <code>push()</code> on starting
 * an async request and <code>pop()</code> if it was finished. With this you can
 * easy show the loader if one or more async requests are running.
 * @type type
 */
var LoadingBar = {
  /**
   * Initialize loading bar and append it to body.
   * @returns {Object}
   * Object to control loading bar.
   */
  init: function () {
    //create node
    var node = document.createElement("div");
    node.id = "loadingBar";
    node.classList.add(
      "mdl-progress",
      "mdl-js-progress",
      "mdl-progress__indeterminate"
    );

    //use visibility to prevent repaint
    node.style.visibility = "hidden";

    //node functions
    node.LoadingBar = {
      /**
       * Internal counter to manage number of async tasks running
       */
      _counter: 0,
      /**
       * Incerments the internal counter and show the loading bar.
       * @returns {undefined}
       */
      push: function () {
        var that = node;

        //if node not visible yet, show
        if (this._counter === 0) that.style.visibility = "visible";

        //count
        this._counter++;
      },
      /**
       * Decrements the internal counter. If counter reach zero, the loading bar
       * will be hidden.
       * @returns {undefined}
       */
      pop: function () {
        var that = node;

        //count
        if (this._counter > 0) this._counter--;

        //on 0, hide
        if (this._counter === 0) that.style.visibility = "hidden";
      },
      /**
       * Sets counter to zero and hide the loading bar.
       * @returns {undefined}
       */
      reset: function () {
        var that = node;

        this._counter = 0;
        that.style.visibility = "hidden";
      },
    };

    //append node to body
    document.body.appendChild(node);

    return node.LoadingBar;
  },
};
